import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import * as IconModule from ".";
var Icons = IconModule;
var IconComponent = function(_param) {
    var iconName = _param.iconName, props = _object_without_properties(_param, [
        "iconName"
    ]);
    var IconElement = Icons["".concat(iconName, "Icon")];
    return IconElement ? /*#__PURE__*/ _jsx(IconElement, _object_spread({}, props)) : null;
};
export default IconComponent;
